<template>
      <tr>
        <td class="price-column-name">{{row_name}}</td>
        <tariff-input
          v-for="(tariff, index) in tariffs"
          :key="index"
          :tariff="tariff"
          :read_only="read_only"
          :tariff_readonly="tariff.readonly"
          :input_name="input_name"
          :model_prop="model_prop"
          :validated_form="validated_form"
          :action="action"
          ref="tariff_input"
          />
      </tr>
</template>

<script>
import {Fragment} from 'vue-fragment'
import {Money} from './../../../services/Money.js';
import Utils from './../../../services/Utils.js';
import TariffInput from './tariffInput.vue';


export default {
  components : {
    Fragment,
    TariffInput
  },
  data: function() {
      return {
          money: new Money(),
          input_value : ''
      }
  },
  props: [
    'row_name',
    'tariffs',
    'input_name',
    'model_prop',
    'read_only',
    'validated_form',
    'action'
  ],
  methods : {
  },
  mounted : function () {
  }
}
</script>

<style lang="css" scoped>
</style>
